module.exports = __webpack_public_path__ + "static/media/sur-eau.2c25dab5.webp";